// extracted by mini-css-extract-plugin
module.exports = {"button":"_b516676","icon":"_e8bbc7ab","disabled":"_884d7010","noText":"_cd279cfc","text":"_1a8d0c7d","upperCase":"_567d54d6"};